import * as Yup from "yup"
import { BookerPaymentMethodInput, PaymentTransferType } from "../../../../generated/graphql"
import { apolloClient } from "../../../ApolloWrapper/ApolloWrapper"
import { GET_BANK_DATA } from "../../../sepaDebitValidation/sepaDebit.graphql"

const { string, object, boolean } = Yup

// @ts-ignore
export const BookerPaymentMethodInputValidationSchema = object().shape<BookerPaymentMethodInput>({
    id: string().required(),
    cash: boolean().notRequired().nullable(),
    creditCardAccountholder: string().notRequired().nullable(),
    creditcardNumber: string().notRequired().nullable(),
    expirationDate: string().notRequired().nullable(),
    cvc: string().notRequired().nullable(),
    validFrom: string().notRequired().nullable(),
    paypalAccountholder: string().notRequired().nullable(),
    email: string().notRequired().nullable(),
    iban: string().when("type", {
        is: PaymentTransferType.SepaDebit,
        then: string()
            .required("Bitte gib eine IBAN ein.")
            .test("validatingIban", 'Bitte gib eine gültige IBAN ein. Bsp.: "DE 11 5205 1373 5120 7101 31, CH93 0076 2011 6238 5295 7, AT61 1904 3002 3457 3201"', async (iban) => {
                if (iban !== undefined) {
                    const { data, errors } = await apolloClient.query({
                        query: GET_BANK_DATA,
                        variables: { iban },
                    })
                    if (errors) {
                        console.log("validatingIban errors: ", errors)
                    }
                    console.log("validatingIban data: ", data)

                    return data.getBankData.valid
                }
            }),
        otherwise: string().notRequired().nullable(),
    }),
    bank: string().when("type", {
        is: PaymentTransferType.SepaDebit,
        then: string().required("Bitte gib eine Bank an."),
        otherwise: string().notRequired().nullable(),
    }),
    bic: string().notRequired().nullable(),
    sepaAccountholder: string().when("type", {
        is: PaymentTransferType.SepaDebit,
        then: string()
            .required("Bitte gib einen Kontoinhaber an.")
            .matches(
                /^([A-Za-z0-9\u00e4\u00fc\u00f6\u00c4\u00dc\u00d6\u00df\u00e0\u00e1\u00e2\u00e3\u00e8\u00e9\u00ea\u00eb\u00ec\u00ed\u00ee\u00ef\u00f1\u00f2\u00f3\u00f4\u00f5\u00f9\u00fa\u00fb\u00c0\u00c1\u00c2\u00c3\u00c8\u00c9\u00ca\u00cb\u00cc\u00cd\u00ce\u00cf\u00d1\u00d2\u00d3\u00d4\u00d5\u00d9\u00da\u00db\u00e7\u00c7\/\-\?\:\(\)\.\,\'\+\s]{2,})(?:,\s+|\s+)([A-Za-z0-9\u00e4\u00fc\u00f6\u00c4\u00dc\u00d6\u00df\u00e0\u00e1\u00e2\u00e3\u00e8\u00e9\u00ea\u00eb\u00ec\u00ed\u00ee\u00ef\u00f1\u00f2\u00f3\u00f4\u00f5\u00f9\u00fa\u00fb\u00c0\u00c1\u00c2\u00c3\u00c8\u00c9\u00ca\u00cb\u00cc\u00cd\u00ce\u00cf\u00d1\u00d2\u00d3\u00d4\u00d5\u00d9\u00da\u00db\u00e7\u00c7\/\-\?\:\(\)\.\,\'\+\s]{2,})$/,
                "Bitte gib den Kontoinhaber mit gültigen SEPA-Zeichen an (A-Z, a-z, 0-9, Umlaute, Akzente und Sonderzeichen: / - ? : ( ) . , ' +)."
            ),
        otherwise: string().notRequired().nullable(),
    }),
    type: string().notRequired().nullable(),
})
